import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { SettingsProvider } from '@/context/SettingsContext';
import AppThemeProvider from '@/theme/ThemeProvider';
import AppLayout from '@/components/AppLayout';

const App: React.FC = () => {
  return (
    <SettingsProvider>
      <AppThemeProvider>
        <BrowserRouter>
          <AppLayout />
        </BrowserRouter>
      </AppThemeProvider>
    </SettingsProvider>
  );
};

export default App;
